import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type TabsProps from "./TabsProps";
import "./Tabs.scss";
import Tab from "@mui/material/Tab";
import TabList from '@mui/lab/TabList';



const TabsList = (props: TabsProps) => {

  const currentActiveTab = props.currentActiveTab;
  
  return (
      <TabList 
        onChange={(event , newValue)=>{
          props.handleChange(event, newValue);
        }}
        className={`tabs`}   
        aria-label=""
        selectionFollowsFocus
        variant="scrollable"
        scrollButtons="auto"      
        role="tablist"
        // aria-labelledby={`tablist-${currentActiveTab}`}
        // TabIndicatorProps={{'aria-label':''}}
      >
      {props?.labels.map((label: string, index : number) => (
        <Tab
          key={index}
          className={`${
            label === currentActiveTab ? "btn-rm-st tab active " : "btn-rm-st tab"
          }`}
          label={label}
          value={label}
          id={`tab-${label}`}
          role={"tab"}
          aria-selected={label === currentActiveTab ? "true" : "false"}
          aria-controls={`tabpanel-${label}`}
          TouchRippleProps={{ center: true }}
        />
      ))}
      </TabList >
  );
};

export default TabsList;

